export default __webpack_public_path__ + "static/media/bizventureglossary.a26bde76.pdf";